<template>
    <div class="w960 mgt30">
        <el-cascader @change="change" :value="val" :options="options" :props="props" style="width: 100%;" size="large" filterable />
    </div>
</template>

<script>
import { CodeToText,TextToCode } from 'element-china-area-data';
const areajson = require('../../assets/js/area.json');
const hall = require('../../assets/js/streets.json');
  export default {
    props: ['value'],
    data() {
      return {
        props: {
          value: 'code',
          label: 'name',
          children: 'children',
        },
        options: areajson,  //areajson为引入外部js文件的json数组名称
      };
    },
    computed:{
      val(){
        const provinceCode = TextToCode[this.value[0]];
        if(!provinceCode) {
          return [];
        }
        const cityCode = provinceCode[this.value[1]];
        const areaCode =  cityCode[this.value[2]];
        return [
            provinceCode.code.slice(0,2),
            cityCode.code.slice(0,4),
            areaCode.code,
            this.hallTextToCode(this.value[3], areaCode.code),
        ];
      },
    },
    methods:{
      change(val){
        this.$emit('input', [
            CodeToText[val[0] + '0000'],
            CodeToText[val[1] + '00'],
            CodeToText[val[2]],
            this.hallCodeToText(val[3]),
        ]);
      },
      hallCodeToText(code) {
        let res = '';
        for(let i = 0; i < hall.length; i ++) {
          if(code === hall[i].code) {
            res = hall[i].name;
            break;
          }
        }
        return res;
      },
      hallTextToCode(name, areaCode){
        console.log(name, areaCode);
        let res = '';
        for(let i = 0; i < hall.length; i ++){
          if(name == hall[i].name && areaCode == hall[i].areaCode){
            res = hall[i].code;
            break;
          }
        }
        return res;
      },
    },
  }
</script>

<style>
